module.exports = __webpack_public_path__ + "img/choithrams-original-960.f8410db4.webp";